// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"c022a57f","990":"408a9c94"}[chunkId] + ".chunk.js";
};